import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

export const StyledUpdatedInfo = styled.div<{ isOld?: boolean }>`
    line-height: 20px;

    ${({ isOld }) =>
        mixins.setFontVariant("sectionTitle", isOld ? colorsPalettes.red["400_P"] : colorsPalettes.carbon[300])};
`;
